<template>
    <div>
        <!--        <div class="nav">课程详情</div>-->

        <div class="course-video">
            <div class="videoBox">
                <video :src="info.videoUrl" controls autoplay preload="auto"
                       webkit-playsinline="true"
                       playsinline="true"
                       x-webkit-airplay="allow"
                       style="object-fit:fill"></video>
            </div>
            <div class="videoTitle">
                <div class="videoTitle-t">
                    <div class="videoTitle-t-one" @click="toAsk">
                        <img class="fb" src="/img/fb.png" v-if="userId&&userId!=''"/>
                    </div>
                    <div class="videoTitle-t-two">
                        <a :href="'/askStart?courseId='+courseId" v-if="courseType==1&&info.questionFlag==1">开始闯关</a>
                        <label @click="show_more">{{showMore?'收起':'展开'}}
                            <img src="/img/zk.png" :style="showMore?'transform:rotate(180deg);':''">
                        </label>
                    </div>
                </div>
                <div class="videoTitle-b">
                    <span>{{info.title}}</span>
                    <div v-if="showMore">
                        {{info.description}}
                    </div>
                </div>

            </div>
        </div>

        <div>
            <div class="njtab">
                <div class="njtab-div active" @click="checkLabel('1')" v-if="checkFlag == '1'">课程</div>
                <div class="njtab-div " @click="checkLabel('0')" v-if="checkFlag == '1'">作业</div>
                <div class="njtab-div" @click="checkLabel('1')" v-if="checkFlag != '1'">课程</div>
                <div class="njtab-div active" @click="checkLabel('0')" v-if="checkFlag != '1'">作业</div>
            </div>
            <div v-if="checkFlag == '1'">
                <!--暂无数据-->
                <div class="no_data" v-if="course_data.list.length==0">
                    <img src="/img/zw.png">
                    <label>暂无数据</label>
                </div>
                <!--暂无数据 end-->
                <div class="xsbox">
                    <div class="xsbox-li" v-for="item of course_data.list" :key="item.id"
                         @click="toUrl(item.courseId,item.courseType,item.courseLevel)">
                        <img :src="imgprefix+item.picUrl">
                        <div class="xsbox-li-r">
                            <div class="xsbox-li-title">{{item.title}}</div>
                            <div class="xsbox-li-sm">{{item.description}}</div>
                            <div class="xsbox-li-tb">
                                <div>
                                    <img src="/img/bf.png" alt="">
                                    <span>{{item.playNum}}</span>
                                </div>
                                <div>
                                    <img src="/img/bj.png" alt="">
                                    <span>{{item.taskNum}}</span>
                                </div>
                                <div>
                                    <img src="/img/time.png" alt="">
                                    <span>{{item.length}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="show" v-if="checkFlag != '1'">
                <div class="task-list" v-for="(item,index) of task_data.list" :key="item.id">
                    <div class="task-img" @click="toTaskUrl(item.id,index)"><img :src="imgprefix+item.pic"></div>
                    <div class="task-name" @click="toTaskUrl(item.id,index)">
                        <span><img :src="imgprefix+item.photo"></span>
                        <b>{{item.nickName}}({{item.author}})</b>
                        <em>{{item.viewTime}}</em>
                    </div>
                    <div class="task-fun">
                            <span class="foleft">
                                <span @click="praise(index)"><img
                                        :src="item.praiseFlag== ''?'img/dz.png':'img/y_dz.png'">{{item.praiseNum || ''}}</span>
                                <span @click="collect(index)"><img
                                        :src="item.collectFlag== ''?'img/sc.png':'img/y_sc.png'"></span>
                                <!--<span><img src="img/fx.png"></span>-->
                                <!--<span><img src="img/xz.png"></span>-->
                            </span>
                        <span class="foright" @click="toTaskUrl(item.id,index)">
                                <img src="img/xx.png">{{item.talkNum||''}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Indicator, Toast} from "mint-ui";
    import wx from 'weixin-js-sdk';
    import Utils from '../../js/common/utils';

    export default {
        name: "courseDetail",
        data() {
            return {
                imgprefix: C.imgprefix,
                currentTab: 0,
                xs: 1,
                courseId: this.$route.query.courseId,
                courseType: this.$route.query.courseType,
                courseLevel: this.$route.query.courseLevel,
                info: {}, //课程详情数据
                showMore: false, //显示课程介绍
                course_data: { //相关课程
                    list: [],
                    page: 1,
                    hasMoreData: true,
                    name: 'course_data'
                },
                task_data: { //作业列表
                    list: [],
                    page: 1,
                    hasMoreData: true,
                    name: 'task_data'
                },
                clickFlag: false,
                showfb: false, //显示写作业按钮
                checkFlag: '1',
                userId: ''
            };
        },
        created() {
            let userId = this.$route.query.userId;
            if (!userId) {
                userId = Utils.getLocal("userId");
            }

            let currentUserToken = this.$route.query.currentUserToken;
            if (!currentUserToken) {
                currentUserToken = Utils.getLocal("userId");
            }
            if (!userId) {
                // Toast("参数错误");
                // return;
            }
            Utils.saveLocal('userId', userId||'');
            Utils.saveLocal('currentUserToken', currentUserToken||'');
            this.userId = userId || '';

            this.get_info()
            this.get_course_list()
        },
        mounted: function () {
            //处理返回去列表
            // if (window.history && window.history.pushState) {
            //
            //     history.pushState(null, null, '/');
            //     window.addEventListener('popstate', this.goBack, false);
            // }

            window.onscroll = () => {
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                if (scrollTop + windowHeight != scrollHeight) {
                    return;
                }
                if (this.checkFlag == '1') {
                    //写后台加载数据的函数
                    this.get_course_list()
                } else {
                    //作业
                    this.get_task_list();
                }
            }
        },
        destroyed() {
            //window.removeEventListener('popstate', this.goBack, false);
        },
        methods: {

            // goBack(){
            //     this.$router.replace({path: '/'});
            //     //replace替换原路由，作用是避免回退死循环
            //     },

            //初始化分享参数
            initShare: function () {
                R.Wechat.queryWechatInfo({url: location.href}).then(res => {
                    wx.config({
                        appId: res.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                        timestamp: res.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.nonceStr, // 必填，生成签名的随机串
                        signature: res.signature,// 必填，签名，见附录1
                        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    });

                    wx.ready(() => {   //需在用户可能点击分享按钮前就先调用
                        wx.updateAppMessageShareData({//分享给微信好友 qq好友
                            title: this.info.title, // 分享标题
                            desc: this.info.description, // 分享描述
                            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: this.imgprefix + this.info.picUrl, // 分享图标
                            success: () => {
                                // 设置成功
                            }
                        })

                        wx.updateTimelineShareData({//分享到朋友圈 qq空间
                            title: this.info.title, // 分享标题
                            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: this.imgprefix + this.info.picUrl, // 分享图标
                            success: () => {
                                // 设置成功
                            }
                        })
                    });
                })
            },
            toUrl: function (id, courseType, courseLevel) {
                window.location.href = `/course?courseId=${id}&courseType=${courseType}&courseLevel=${courseLevel}`
            },
            toTaskUrl: function (taskId, preIndex) {
                window.location.href = `/taskDetail?taskId=${taskId}&preIndex=${preIndex}&userId=${this.userId}`
            },
            toAsk: function () {
                if (!this.userId) {
                    return
                }
                window.location.href = `/addTask?userId=${this.userId}&courseId=${this.courseId}`
            },
            //获取详情
            get_info: function () {
                let {
                    courseId
                } = this
                R.Course.getInfo({
                    courseId
                }).then(result => {
                    this.info = {...result}
                    this.initShare()
                })
            },
            //展开，收缩
            show_more: function () {
                this.showMore = !this.showMore
            },

            //课程列表
            get_course_list: function () {
                if (this.requestLoading) {
                    return
                }
                this.requestLoading = true
                let {
                    course_data,
                    courseId,
                } = this
                if (!course_data.hasMoreData) {
                    Toast('无更多数据');
                    return
                }
                Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                });
                R.Course.findCourseListById({
                    courseId,
                    page: course_data.page,
                    limit: 10
                }).then(result => {
                    Indicator.close();
                    this.requestLoading = false
                    result.data.rows.forEach((item) => {
                        this.course_data.list.push(item)
                    })
                    this.course_data.page++
                    if (this.course_data.list.length >= result.data.total) {
                        this.course_data.hasMoreData = false
                    }
                })
            },
            //查询作业列表
            get_task_list: function () {
                if (this.requestLoading) {
                    return
                }
                this.requestLoading = true
                let {
                    task_data,
                    courseId
                } = this
                if (!task_data.hasMoreData) {
                    Toast('无更多数据');
                    return
                }
                Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                });
                R.Course.getTaskList({
                    courseId,
                    type: 4,
                    roleType: '',
                    userId: this.userId,
                    page: task_data.page,
                    limit: 10
                }).then(result => {
                    Indicator.close();
                    this.requestLoading = false
                    result.data.rows.forEach((item) => {
                        this.task_data.list.push(item)
                    })
                    this.task_data.page++
                    if (this.task_data.list.length >= result.data.total) {
                        this.task_data.hasMoreData = false
                    }
                })
            },
            //切换
            checkLabel: function (checkFlag) {
                if (checkFlag == '1') {
                    //课程列表
                    let course_data = this.course_data;
                    course_data.page = 1;
                    course_data.hasMoreData = true;
                    this.get_course_list();
                } else {
                    //作业
                    let task_data = this.task_data;
                    task_data.page = 1;
                    task_data.hasMoreData = true;
                    this.get_task_list();
                }
                this.checkFlag = checkFlag;
            },
            //点赞|取消赞
            praise: function (index) {
                let {
                    clickFlag = false, task_data
                } = this

                let type = 2
                if (clickFlag) {
                    return
                }
                this.clickFlag = true;
                let {
                    id,
                    praiseNum,
                    praiseFlag,
                    userId
                } = task_data.list[index]
                praiseNum--
                if (praiseFlag == '') { //未点过赞
                    type = 1
                    praiseNum = praiseNum + 2
                }
                R.Course.setPraise({
                    readId: id,
                    userId: userId,
                    type
                }).then(result => {
                    console.log(result.code);
                    this.task_data.list[index].praiseFlag = type == 1 ? '1' : '';
                    this.task_data.list[index].praiseNum = praiseNum;
                    this.clickFlag = false;
                })


            },

            //收藏|取消
            collect: function (index) {
                let {
                    task_data,
                    clickFlag = false
                } = this, type = 2
                if (clickFlag) {
                    return
                }
                this.clickFlag = true;
                let {
                    id,
                    collectFlag,
                    userId,
                } = task_data.list[index]
                if (collectFlag == '') { //未收藏过
                    type = 1
                }


                R.Course.taskCollect({
                    readId: id,
                    userId: userId,
                    type
                }).then(result => {
                    console.log(result)
                    this.task_data.list[index].collectFlag = type == 1 ? '1' : '';
                    this.clickFlag = false;

                })


            },


        }
    }
</script>

<style scoped>

    .njtab {
        border-top: 10px solid #ebecea;
        height: 51px;
        line-height: 42px;
        font-size: 15px;
        color: #000;
        padding: 0 10px;
        display: flex;
        justify-content: space-around;
        border-bottom: 1px solid #edeeec;
    }

    .njtab-div {
        width: calc((100% - 30px) / 4);
        height: 100%;
        margin-right: 10px;
        display: inline-block;
        text-align: center;
    }

    .njtab-div:last-child {
        margin-right: 0;
    }

    .njtab-div.active {
        color: #32a658;
        height: 40px;
        border-bottom: 2px solid #32a658;
    }

    .lbtab {
        height: 56px;
        padding: 0 10px;
        border-bottom: 1px solid #edeeec;
    }

    .lbtab-div {
        width: auto;
        height: 32px;
        border-radius: 16px;
        border: solid 1px rgba(101, 97, 97, 0.35);
        font-size: 15px;
        color: #000;
        padding: 0 19px;
        line-height: 32px;
        margin: 12px 5px;
        display: inline-block;
    }

    .lbtab-div.on {
        background-color: #32a658;
        color: #fff;
    }

    .xsbox {
        padding: 0 15px;
    }

    .xsbox-li {
        height: 117px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #edeeec;
    }

    .xsbox-li img {
        width: 115px;
        height: 77px;
        border-radius: 3px;
    }

    .xsbox-li .xsbox-li-r {
        font-size: 12px;
        width: calc(100% - 130px);
    }

    .xsbox-li-title {
        width: 100%;
        font-size: 16px;
        color: #000;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .xsbox-li-sm {
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 10px 0 13px 0;
    }

    .xsbox-li-tb img {
        width: 12px;
        height: 12px;
        vertical-align: -2px;
        margin-right: 3px;
    }

    .xsbox-li-tb {
        font-size: 13px;
        color: #333;
    }

    .xsbox-li-tb div {
        width: calc(100% / 3);
        text-align: left;
        float: left;
    }

    .xsbox-li-tb div span {
        display: inline;
    }

    .show {
        display: block;
        padding: 12px;
    }

    .videoTitle-t a {
        /*float: right;*/
        display: inline-block;
        margin-right: 5px;
        width: 82px;
        height: 27px;
        text-align: center;
        line-height: 27px;
        border-radius: 100px;
        background: #FFC71C;
        font-size: 13px;
        color: #ffffff;
        font-weight: bold
    }

    .hidden {
        display: none;
    }

    .course-video {
        /*padding-top: 48px;*/
    }

    .course-video video,
    .videoBox {
        height: 211px;
        width: 100%;
    }

    .videoTitle {
        /* height: 152px; */
        font-size: 17px;
        color: #000;
    }

    .videoTitle .videoTitle-t {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        height: 37px;
        background-color: #f1f1f1;
    }

    .videoTitle-t-one img {
        width: 16px;
        height: 16px;
        vertical-align: -3px;
    }

    .videoTitle-t-one img.share {
        padding-left: 0;
        border-right: 1px solid #cacaca;
    }

    .videoTitle-t-one img.fb {
        padding-right: 0;
    }

    .vto-div {
        display: inline-block;
        position: relative;
    }

    .vto-div button {
        position: absolute;
        width: 16px;
        top: 5px;
        left: 0;
        height: 16px;
        background: transparent;
    }

    button::after {
        border: none;
    }

    .videoTitle-t-two {
        font-size: 12px;
        color: #0084ff;
    }

    .videoTitle-t-two img {
        width: 9px;
        height: 10px;
        vertical-align: -1px;
    }

    .videoTitle-b {
        padding: 0 15px;
    }

    .videoTitle-b span {
        font-weight: bold;
        display: block;
        font-size: 17px;
        color: #000;
        padding: 13px 0 10px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .videoTitle-b div {
        font-size: 12px;
        line-height: 19px;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        /*-webkit-line-clamp: 3;*/
        padding-bottom: 15px;
    }

    .zybox {
        padding: 0 15px;
    }

    .zybox-li {
        /* height: 275px; */
        border-bottom: 1px solid #edeeec;
    }

    .zybox-li > img {
        /* width: 100%; */
        /* height: 180px; */
        max-height: 250px;
        border-radius: 8px;
        margin-top: 11px;
    }

    .zybox-li .zybox-li-r {
        font-size: 14px;
        width: 100%;
    }

    .zybox-li-title {
        width: 100%;
        display: flex;
        align-items: center;
        color: #666;
        justify-content: space-between;
    }

    .zybox-li-title-l {
        color: #353535;
        display: flex;
        align-items: center;
        width: calc(100% - 130px);
        margin-top: 10px;
    }

    .zybox-li-title-l text {
        /* width: calc(100% - 40px); */
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .zybox-li-title-l img {
        width: 24px;
        height: 24px;
        border-radius: 12px;
        margin-right: 5px;
        margin-top: 0;
    }

    .zybox-li-sm {
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 10px 0 13px 0;
    }

    .zybox-li-tb img {
        vertical-align: -5px;
        margin-right: 3px;
    }

    .zybox-li-tb {
        font-size: 13px;
        color: #333;
        margin-top: 11px;
    }

    .zybox-li-tb div {
        display: inline-block;
        margin-right: 20px;
        color: #010101;
        opacity: 0.8;
    }

    .zybox-li-tb div:nth-child(1) img {
        width: 22px;
        height: 20px;
    }

    .zybox-li-tb div:nth-child(2) img {
        width: 24px;
        height: 23px;
    }

    .zybox-li-tb div:nth-child(3) img {
        width: 21px;
        height: 21px;
    }

    .zybox-li-tb div:nth-child(4) img {
        width: 20px;
        height: 21px;
    }

    .zybox-li-tb div:nth-child(5) img {
        width: 21px;
        height: 20px;
    }

    .zybox-li-tb div:nth-child(5) {
        float: right;
        margin-right: 0;
    }

    .zs_people {
        margin: 8px 0;
        height: 24px;
        overflow: hidden;
    }

    .left-p {
        float: left;
        width: auto;
        max-width: calc(100% - 108px);
        height: 24px;
        line-height: 24px;
        overflow: hidden;
    }

    .zs_people img {
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 100%;
        vertical-align: top;
        margin-left: -4px;
    }

    .zs_people img:nth-of-type(1) {
        margin-left: 0;
    }

    .tips {
        font-size: 12px;
        color: #000;
        display: inline-block;
        height: 24px;
        line-height: 24px;
        margin-left: 9px;
        float: left;
        width: 112px;
    }

    .tips label {
        color: #32a658;
        margin: 0 5px;
        font-weight: bold;
    }

    .tips img {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-left: 5px;
        vertical-align: -2px;
    }

    .t_search {
        padding: 10px 15px;
        background: #fff;
        color: #9a9a9a;
        font-size: 14px;
        position: fixed;
        width: calc(100% - 30px);
        left: 0;
        top: 126px;
        z-index: 999;
    }

    .t_search input {
        float: left;
        background: #fff;
        font-size: 14px;
        padding: 0 5px;
        color: #353535;
        width: calc(100% - 56px);
        height: 20px;
        line-height: 20px;
        vertical-align: top;
        border-right: 1px solid #b2b2b2;
    }

    .t_search button {
        width: 20px;
        height: 20px;
        display: inline-block;
        float: left;
        margin: 0 7px 0 18px;
        background: none;
        border: none;
        padding: 0;
    }

    .t_search button img {
        width: 20px;
        height: 20px;
        display: block;
        margin: 0 auto;
    }

    .nav {
        height: 48px;
        padding-top: 20px;
        width: 100%;
        position: fixed;
        top: 0;
        text-align: center;
        display: flex;
        flex-direction: row;
        z-index: 9999;
        background: #F8F8F8;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        line-height: 24px;
        margin: 0;
        padding: 0;
        font-weight: 600;
    }

    .task-list {
        border-bottom: 1px solid #e4e4e4;
        padding-bottom: 15px;
        margin-bottom: 16px;
    }

    .task-img {
        border-radius: 6px;
        overflow: hidden
    }

    .task-list img {
        width: 100%;
        border-radius: 6px;
    }

    .task-name {
        height: 45px;
        line-height: 45px;
    }

    .task-name span {
        width: 24px;
        height: 24px;
        border-radius: 100px;
        overflow: hidden
    }

    .task-name span img {
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 100px;
        position: relative;
        top: 5px;
    }

    .task-name b {
        font-size: 14px;
        color: #000;
        font-weight: normal;
    }

    .task-name em {
        float: right;
        font-size: 12px;
        color: #666666;
    }

    .task-fun {
        height: 25px;
    }

    .task-fun {
    }

    .foleft {
        float: left;
    }

    .foright {
        float: right
    }

    .task-fun span.foright span {
        display: inline-block;
        height: 25px;
        font-size: 14px;
        color: #000000;
    }

    .task-fun span.foleft span {
        display: inline-block;
        height: 25px;
        font-size: 14px;
        color: #000000;
        margin-right: 19px
    }

    .task-fun span img {
        width: 23px;
        position: relative;
        top: 4px;
    }
</style>
